import { RemoteUpdateScheduledPushNotification } from 'data/usecases';
import { UpdateScheduledPushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlUpdateScheduledPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeUpdateScheduledPushNotification =
  (): UpdateScheduledPushNotificationUseCaseInterface =>
    new RemoteUpdateScheduledPushNotification(
      makeApiUrlUpdateScheduledPushNotification(),
      makeAxiosHttpClient(),
    );
